import { render, staticRenderFns } from "./DocumentosPorProgramaLayout.vue?vue&type=template&id=cd01c478&scoped=true"
import script from "./DocumentosPorProgramaLayout.vue?vue&type=script&lang=js"
export * from "./DocumentosPorProgramaLayout.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPorProgramaLayout.vue?vue&type=style&index=0&id=cd01c478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd01c478",
  null
  
)

export default component.exports